module.exports = __webpack_public_path__ + "static/media/arrangement.1baf6278.png";